export const selectAnalyticsPrice = state => state.addon.analytics.price;
export const selectAddOn = state => state.addon;
export const selectActiveAnalytics = state => state.addon.analytics.plan;
export const selectAllAnalyticsPrices = state => state.addon.analytics.prices;